module.exports = __webpack_public_path__ + "static/media/snoopyclearnight02.3fae0d8f.gif";